import React, { useState } from 'react'
import { toast } from "react-toastify"
import { useDispatch, useSelector } from 'react-redux'
import CenteredModal from '../../../../CenteredModal'
import FormValidators from '../../../../../../helpers/FormValidators'
import FormValidationMessages from '../../../../../../constants/FormValidationMessages'
import './style.sass'
import { PasswordField } from '../../../../FormFields'
import { updateClientSecret } from '../../../../../../redux/actions/application'

const UpdateClientSecret = ({ releaseId, clientId }) => {

  // ==== Redux state ====
  const dispatch = useDispatch()
  const isUpdatingClientSecret = useSelector(({ application }) => application.isUpdatingClientSecret)

  // ==== Local state ====
  const [secretValue, setSecretValue] = useState("")
  const [errorMessage, setErrorMessage] = useState(null)
  const [updateSecretModalIsVisible, setUpdateSecretModalIsVisible] = useState(false)

  // ==== Methods ====
  const onUpdateClicked = async () => {
    const isValid = validateForm(secretValue)
    if (!isValid) {
      toast.error('Please enter a valid secret value!')
      return
    }
    const res = await dispatch(updateClientSecret(releaseId, clientId, secretValue))

    if (res) {
      toast.success('Successfully updated secret!')
      setUpdateSecretModalIsVisible(false)
      setSecretValue("")
      return
    }
    toast.error('Something went wrong!')
  }

  const onCancel = () => {
    setSecretValue("")
    setErrorMessage(null)
    setUpdateSecretModalIsVisible(false)
  }

  const onChangeHandler = (value) => {
    setSecretValue(value)
    validateForm(value)
  }

  const validateForm = (value) => {
    if (FormValidators.isNullOrEmpty(value)) {
      setErrorMessage(FormValidationMessages.REQUIRED)
      return false
    }
    setErrorMessage(null)
    return true
  }

  return (
    <div className="update-client-secret-component-container">
      <p className="update-client-secret-field-label">For authentication you need to use a client secret</p>
      <p className="update-client-secret-btn" onClick={() => { setUpdateSecretModalIsVisible(true) }} >
        <i className="fa fa-pencil-square-o"></i>
        Update Client Secret
      </p>
      <CenteredModal
        show={updateSecretModalIsVisible}
        title="Update Client Secret"
        successBtnText="Update"
        onSuccess={onUpdateClicked}
        cancelBtnText="Cancel"
        onHide={onCancel}
        btnDisabled={isUpdatingClientSecret}
      >
        <div>
          <PasswordField
            displayName="Client Secret"
            description="Please remember the secret you enter. You cannot view it after updating it."
            value={secretValue}
            onChange={onChangeHandler}
            errorMessage={errorMessage}
            isCreateNewModeDefault={true}
            disabled={isUpdatingClientSecret}
          />
        </div>
      </CenteredModal>
    </div>
  )
}

export default UpdateClientSecret
